import { z } from "zod";
import { CommonModels } from "@/data/common/common.models";

export namespace WatchlistModels {
/** 
 * WatchlistJobFitListItemDtoSchema 
 * @type { object }
 * @property { string } jobTitle  
 * @property { number } fitScore  
 * @property { string } status  
 */
export const WatchlistJobFitListItemDtoSchema = z.object({ jobTitle: z.string(), fitScore: z.number(), status: CommonModels.StatusEnumSchema });
export type WatchlistJobFitListItemDto = z.infer<typeof WatchlistJobFitListItemDtoSchema>;


/** 
 * WatchlistJobFitListResponseDtoSchema 
 * @type { object }
 * @property { WatchlistJobFitListItemDto[] } items  
 */
export const WatchlistJobFitListResponseDtoSchema = z.object({ items: z.array(WatchlistJobFitListItemDtoSchema) });
export type WatchlistJobFitListResponseDto = z.infer<typeof WatchlistJobFitListResponseDtoSchema>;


/** 
 * WatchlistJobFitActionDtoSchema 
 * @type { object }
 * @property { number } step  
 * @property { string } title  
 * @property { string } description  
 */
export const WatchlistJobFitActionDtoSchema = z.object({ step: z.number(), title: z.string(), description: z.string().nullish() });
export type WatchlistJobFitActionDto = z.infer<typeof WatchlistJobFitActionDtoSchema>;


/** 
 * FitScoreBreakdownDtoSchema 
 * @type { object }
 * @property { string } eduGrade  
 * @property { string } expGrade  
 * @property { string } skillsGrade  
 * @property { string } certificationsGrade  
 * @property { string } projectsGrade  
 */
export const FitScoreBreakdownDtoSchema = z.object({ eduGrade: z.string().nullable(), expGrade: z.string().nullable(), skillsGrade: z.string().nullable(), certificationsGrade: z.string().nullable(), projectsGrade: z.string().nullable() }).partial();
export type FitScoreBreakdownDto = z.infer<typeof FitScoreBreakdownDtoSchema>;


/** 
 * WatchlistJobFitDtoSchema 
 * @type { object }
 * @property { string } id  
 * @property { string } jobTitle  
 * @property { number } fitScore  
 * @property { WatchlistJobFitActionDto[] } actions  
 * @property { string } status  
 * @property { FitScoreBreakdownDto } fitScoreBreakdown  
 */
export const WatchlistJobFitDtoSchema = z.object({ id: z.string(), jobTitle: z.string(), fitScore: z.number().nullable(), actions: z.array(WatchlistJobFitActionDtoSchema), status: CommonModels.StatusEnumSchema, fitScoreBreakdown: FitScoreBreakdownDtoSchema.nullable() });
export type WatchlistJobFitDto = z.infer<typeof WatchlistJobFitDtoSchema>;


/** 
 * WatchlistJobFitFindByTitleResponseDtoSchema 
 * @type { object }
 * @property { WatchlistJobFitDto } data  
 */
export const WatchlistJobFitFindByTitleResponseDtoSchema = z.object({ data: WatchlistJobFitDtoSchema.nullable() });
export type WatchlistJobFitFindByTitleResponseDto = z.infer<typeof WatchlistJobFitFindByTitleResponseDtoSchema>;


/** 
 * CalculateJobFitDtoSchema 
 * @type { object }
 * @property { string } jobTitle  
 * @property { string } industry  
 * @property { string } subIndustry  
 */
export const CalculateJobFitDtoSchema = z.object({ jobTitle: z.string(), industry: z.string().nullable(), subIndustry: z.string().nullable() });
export type CalculateJobFitDto = z.infer<typeof CalculateJobFitDtoSchema>;


/** 
 * FindJobFitByTitleDtoSchema 
 * @type { object }
 * @property { string } jobTitle  
 */
export const FindJobFitByTitleDtoSchema = z.object({ jobTitle: z.string() });
export type FindJobFitByTitleDto = z.infer<typeof FindJobFitByTitleDtoSchema>;


}
